export const QueryKeys = {
  AllRoles: "allRoles",
  CurrentUserRoles: "currentUserRoles",
  UserRoles: "userRoles",
  OrganizationUserRoles: "organizationUserRoles",
  AreaAccess: "areaAccess",
};
